export default "__VITE_ASSET__B7_Cd8Gj__"